import { MenuItemInfo } from '@tableau/widgets';
import * as React from 'react';
import { defaultMemoize } from 'reselect';

import { Messages } from '../../../codegen/Localize';
import { classes, cssClass } from '../../../style';
import { SelectionMenu } from './SelectionMenu';
import { ActionsMenu, ActionsMenuItem } from './SharedWidgetsActionMenu';

const cssPrefix = 'ActionBar';

const rootClass = cssClass(cssPrefix, 'root', {
  flex: '0 0 auto'
});

export type ActionBarButton = {
  readonly label: string;
  readonly execute: () => void;
};

export type ActionBarProps = {
  readonly actionButtons: ReadonlyArray<ActionBarButton>;
  readonly actionsMenuItems: ReadonlyArray<ActionsMenuItem>;
  readonly anyActionsAllowed: boolean;
  readonly selectionSize: number;
  readonly selectAll?: () => void;
  readonly clear?: () => void;
};

export class ActionBar extends React.PureComponent<ActionBarProps> {

  public render(): JSX.Element {
    return (
      <div className={classes('tb-action-bar', rootClass)}>
        {this.actionBarLeft()}
        {this.actionBarRight()}
      </div>
    );
  }

  private actionBarLeft(): JSX.Element {
    return (
      <div className="tb-action-bar-left">
        {this.renderActionButtons()}
        {this.renderSelectionMenuAndActionsMenu()}
      </div>
    );
  }

  private renderActionButtons(): JSX.Element[] {
    return this.props.actionButtons.map((action, index) => (
      <span
        className={classes('tb-outline-button', 'tb-new-button', 'tb-margin-right-wide')}
        tabIndex={index}
        onClick={action.execute}
      >
        <span className="tb-create-new-icon" />
        <span>{action.label}</span>
      </span>
    ));
  }

  private renderSelectionMenuAndActionsMenu(): JSX.Element {
    if (this.props.anyActionsAllowed) {
      return (
        <span className="tb-select-action-menu-container">
          <SelectionMenu
            selectionSize={this.props.selectionSize}
            selectAll={this.props.selectAll}
            clear={this.props.clear}
          />
          {this.renderActionsMenu()}
        </span>
      );
    }
  }

  private renderActionsMenu(): JSX.Element | null {
    if (this.props.selectionSize > 0 && this.props.actionsMenuItems.length > 0) {
      return (
        <React.Fragment>
          <span className="tb-action-bar-divider"/>
          <ActionsMenu
            actions={this.props.actionsMenuItems}
            buttonLabel={`\u25be ${Messages.actions()}`}
          />
        </React.Fragment>
      );
    } else {
      return null;
    }
  }

  // TODO: Implement actionBarRight
  private actionBarRight(): JSX.Element {
    return null;
  }

}
